const moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(4115), __webpack_require__.e(1500), __webpack_require__.e(1511), __webpack_require__.e(9117), __webpack_require__.e(7495), __webpack_require__.e(1931), __webpack_require__.e(100), __webpack_require__.e(2574), __webpack_require__.e(5320)]).then(() => (() => ((__webpack_require__(30163)))));
	},
	"./AISearchPanel": () => {
		return Promise.all([__webpack_require__.e(4115), __webpack_require__.e(1500), __webpack_require__.e(1511), __webpack_require__.e(9117), __webpack_require__.e(7495), __webpack_require__.e(1931), __webpack_require__.e(100), __webpack_require__.e(2574), __webpack_require__.e(4578)]).then(() => (() => ((__webpack_require__(17285)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});